import type { Category } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";
import { optionSchema } from "../models";

export const getStateOptions = async (categorySlug?: Category["slug"]) => {
  const response = await privateAPI.get(`/states`, {
    params: { category: categorySlug },
  });

  return parseResponseData(response, optionSchema.array());
};
